import type { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { controlTokens, surfaceTokens, radiusTokens } from '@/theme/themePrimitives';

interface FormSectionHeaderProps {
  n: number;
  title: string;
  hint?: string;
  action?: ReactNode;
}

const FormSectionHeader = ({ n, title, hint, action }: FormSectionHeaderProps) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center" mb={2.5} flexWrap="wrap" useFlexGap>
      <Box sx={sx.sectionNumber}>{n}</Box>

      <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'text.primary' }}>
        {title}
      </Typography>

      {hint ? (
        <Box component="span" sx={sx.hint}>
          {hint}
        </Box>
      ) : null}

      {action ? <Box sx={{ ml: 'auto' }}>{action}</Box> : null}
    </Stack>
  );
};

export default FormSectionHeader;

const sx = {
  sectionNumber: {
    width: 28,
    height: 28,
    borderRadius: '8px',
    backgroundColor: controlTokens.primary,
    color: surfaceTokens.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 700,
    flexShrink: 0,
  },
  hint: {
    px: 1,
    py: 0.25,
    borderRadius: radiusTokens.pill,
    bgcolor: surfaceTokens.section,
    color: controlTokens.primary,
    fontSize: 11,
    fontWeight: 600,
  },
};
